import React from 'react'
import { Button } from '@mui/material';
import Styles from "../../Styles/DashBoard.module.css";
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';


function Data3() {
  return (
    <div className={Styles.subsection2}>
                  <div className={Styles.card1}>
                  <div className={Styles.carddetails}  id={Styles.carddetail2}>
                  <ul>
                      <li className={Styles.head2} >Job details</li>
                      <li className={Styles.head3}  >Front-end Developer</li>
                      <li>Cdlp Hub Ltd</li>
                      <li>ibadan</li>
                      <li>on-site</li>
                     </ul>
                     <div className={Styles.infomain}>
                     <div className={Styles.infolist} style={{ position:"relative", left:"40px", top:"22px"}}>
                       <BusinessCenterOutlinedIcon sx={{ width:"16.67px", height:"15.83px" , color:"rgba(243, 114, 63, 1)"}}/>
                        <p>contract</p>
                     </div>
                     <Button sx={{ width:"113px" , height:"43px" ,fontSize:"12px", background: "rgba(243, 114, 63, 1)" ,color:"#fff", position:"relative" , top:"60px", "&:hover": { backgroundColor:"rgba(243, 114, 63, 1)"}}}>Find Jobs</Button>
                     </div>
                  </div>
                  </div>
                  <div className={Styles.card2}>
                   <div className={Styles.card2details}>
                    <h3>Job summary</h3>
                    <div className={Styles.cardinfo}>
                      <p>We are looking to hire a Frontend Developer that will help create products with a good user experience. The UI/UX designer will be responsible for understanding what users want from their device and then designing it so they can find all of its features easily without any hassle. They must also make sure everything works properly when combined in one package.</p>
                    <ul>
                    <li>Minimum Qualification:HND </li>
                    <li>Experience Level:Mid level </li>
                    <li>Job Description/Requirements</li>
                    </ul>
                    <p>Job Description/Requirements</p>
                    <p>Responsibilities:</p>
                    <ul>
                    <li>Gather and evaluate user requirements in collaboration with product managers and engineers.</li>
                     <li>Illustrate design ideas.</li>
                     <li>Design graphic user interface elements.</li>
                     <li>Build page navigation buttons and search fields.</li>
                     <li>At least 2 years of Proven work experience as a Frontend Developer.</li>
                     <li>Ability to design artwork for products.</li>
                     <li>Portfolio of design projects.</li>
                     <li>Up-to-date knowledge of design software like adobe illustrator & photoshop and Figma.</li>
                     <li>Team spirit, and strong communication skills.</li>
                     <li>Good time management skills.</li>
                    </ul>
                    </div>
                   </div>
                  </div>
                 </div>
  )
}

export default Data3